module.exports = __webpack_public_path__ + "img/domain-02.1a9fe4dc.png";